import { render, staticRenderFns } from "./BitacoraResultRow.vue?vue&type=template&id=6364062c&scoped=true"
import script from "./BitacoraResultRow.vue?vue&type=script&lang=js"
export * from "./BitacoraResultRow.vue?vue&type=script&lang=js"
import style0 from "./BitacoraResultRow.vue?vue&type=style&index=0&id=6364062c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6364062c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6364062c')) {
      api.createRecord('6364062c', component.options)
    } else {
      api.reload('6364062c', component.options)
    }
    module.hot.accept("./BitacoraResultRow.vue?vue&type=template&id=6364062c&scoped=true", function () {
      api.rerender('6364062c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/Bitacora/BitacoraResultRow.vue"
export default component.exports